import { render, staticRenderFns } from "./resource-delete-modal.vue?vue&type=template&id=4557e434&"
import script from "./resource-delete-modal.vue?vue&type=script&lang=js&"
export * from "./resource-delete-modal.vue?vue&type=script&lang=js&"
import style0 from "./resource-delete-modal.vue?vue&type=style&index=0&id=4557e434&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports